const ATOM = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
      fill="#1B1E36"
    />
    <path
      d="M10.0206 1.27582C8.94113 1.27582 8.06585 5.19102 8.06585 10.0207C8.06585 14.8504 8.94113 18.7656 10.0206 18.7656C11.1 18.7656 11.9753 14.8504 11.9753 10.0207C11.9753 5.19102 11.1 1.27582 10.0206 1.27582ZM10.1555 18.2721C10.0321 18.4367 9.90865 18.3132 9.90865 18.3132C9.41153 17.7372 9.16297 16.6671 9.16297 16.6671C8.29345 13.8688 8.50041 7.86054 8.50041 7.86054C8.90905 3.09062 9.65241 1.96382 9.90537 1.71366C9.93121 1.68813 9.96522 1.67252 10.0014 1.6696C10.0376 1.66667 10.0737 1.67661 10.1033 1.69766C10.4703 1.95774 10.7782 3.04542 10.7782 3.04542C11.6872 6.4199 11.6049 9.58862 11.6049 9.58862C11.6872 12.3458 11.1494 15.4322 11.1494 15.4322C10.7354 17.7778 10.1555 18.2721 10.1555 18.2721Z"
      fill="white"
    />
    <path
      d="M17.6058 5.66877C17.0683 4.73213 13.2371 5.92141 9.04577 8.32477C4.85449 10.7281 1.89801 13.4359 2.43505 14.3721C2.97209 15.3084 6.80378 14.1195 10.9951 11.7161C15.1863 9.31277 18.1428 6.60501 17.6058 5.66877ZM2.93089 14.2437C2.72513 14.2177 2.77161 14.0486 2.77161 14.0486C3.02401 13.3309 3.82721 12.5828 3.82721 12.5828C5.82265 10.4359 11.1375 7.62557 11.1375 7.62557C15.4779 5.60621 16.826 5.69141 17.168 5.78557C17.2031 5.79537 17.2336 5.81728 17.2541 5.84741C17.2746 5.87755 17.2838 5.91396 17.28 5.95021C17.2389 6.39821 16.4467 7.20621 16.4467 7.20621C13.9737 9.67493 11.184 11.1807 11.184 11.1807C8.83338 12.6247 5.88857 13.6934 5.88857 13.6934C3.64785 14.5009 2.93089 14.2437 2.93089 14.2437Z"
      fill="white"
    />
    <path
      d="M17.5868 14.4033C18.1284 13.4692 15.1794 10.749 11.0028 8.32755C6.82625 5.90612 2.99545 4.70212 2.45433 5.63788C1.91321 6.57364 4.86177 9.2922 9.04073 11.7136C13.2197 14.1351 17.0457 15.3392 17.5868 14.4033ZM2.81321 5.99884C2.73321 5.80916 2.90209 5.76348 2.90209 5.76348C3.64977 5.62228 4.70001 5.94404 4.70001 5.94404C7.55721 6.59468 12.652 9.78604 12.652 9.78604C16.5746 12.5309 17.1762 13.74 17.2664 14.0832C17.2756 14.1184 17.272 14.1557 17.2563 14.1885C17.2407 14.2213 17.2139 14.2476 17.1808 14.2626C16.7718 14.4499 15.6762 14.1708 15.6762 14.1708C12.2997 13.2655 9.59929 11.6067 9.59929 11.6067C7.17297 10.298 4.77377 8.28444 4.77377 8.28444C2.95073 6.74948 2.81377 6.00092 2.81377 6.00092L2.81321 5.99884Z"
      fill="white"
    />
    <path
      d="M10 11.0288C10.5682 11.0288 11.0288 10.5682 11.0288 10C11.0288 9.43185 10.5682 8.97124 10 8.97124C9.43182 8.97124 8.97121 9.43185 8.97121 10C8.97121 10.5682 9.43182 11.0288 10 11.0288Z"
      fill="white"
    />
    <path
      d="M14.2181 6.66669C14.5476 6.66669 14.8148 6.39032 14.8148 6.04941C14.8148 5.70849 14.5476 5.43213 14.2181 5.43213C13.8885 5.43213 13.6214 5.70849 13.6214 6.04941C13.6214 6.39032 13.8885 6.66669 14.2181 6.66669Z"
      fill="white"
    />
    <path
      d="M4.42385 8.76547C4.75341 8.76547 5.02057 8.4891 5.02057 8.14819C5.02057 7.80728 4.75341 7.53091 4.42385 7.53091C4.09429 7.53091 3.82713 7.80728 3.82713 8.14819C3.82713 8.4891 4.09429 8.76547 4.42385 8.76547Z"
      fill="white"
    />
    <path
      d="M8.78601 16.3375C9.11557 16.3375 9.38273 16.0611 9.38273 15.7202C9.38273 15.3793 9.11557 15.1029 8.78601 15.1029C8.45645 15.1029 8.18929 15.3793 8.18929 15.7202C8.18929 16.0611 8.45645 16.3375 8.78601 16.3375Z"
      fill="white"
    />
  </svg>
);
export default ATOM;
